import apiRequest from './api';

export function getBranches(token, businessId) {
  return apiRequest(`/branches?customer_id=${businessId}`, {
    method: 'GET',
    token,
  });
}

export function createBranch(token, payload) {
  return apiRequest('/branches', {
    method: 'POST',
    token,
    body: JSON.stringify(payload),
  });
}

export function updateBranch(token, branchId, payload) {
  return apiRequest(`/branches/${branchId}`, {
    method: 'PATCH',
    token,
    body: JSON.stringify(payload),
  });
}
